module.exports = __webpack_public_path__ + "img/gd-granazi2.f489c64a.png";